module.exports = "/assets/images/b34cd4fbf0def5b545124eee31b57c66.svg";